(function () {
  'use strict';

  /*
    KALINUMX – Safe media volume control v5
    - video + audio
    - no MutationObserver
    - no controls forcing
    - no homepage
    - ignores header/footer
    - default volume 25 %
    - panel appears when media is playing or clicked
  */

  var STORAGE_VOLUME = 'kx_media_volume_v5';
  var STORAGE_MUTED = 'kx_media_muted_v5';
  var DEFAULT_VOLUME = 0.25;
  var hideTimer = null;
  var scanTimer = null;
  var scanCount = 0;

  function isHomepage() {
    return (
      document.body &&
      (
        document.body.classList.contains('template-index') ||
        window.location.pathname === '/' ||
        window.location.pathname === ''
      )
    );
  }

  function readVolume() {
    try {
      var saved = localStorage.getItem(STORAGE_VOLUME);
      var value = saved === null ? DEFAULT_VOLUME : parseFloat(saved);
      if (isNaN(value)) return DEFAULT_VOLUME;
      return Math.max(0, Math.min(1, value));
    } catch (e) {
      return DEFAULT_VOLUME;
    }
  }

  function readMuted() {
    try {
      return localStorage.getItem(STORAGE_MUTED) === 'true';
    } catch (e) {
      return false;
    }
  }

  function saveVolume(value) {
    try {
      localStorage.setItem(STORAGE_VOLUME, String(value));
    } catch (e) {}
  }

  function saveMuted(value) {
    try {
      localStorage.setItem(STORAGE_MUTED, String(value));
    } catch (e) {}
  }

  function isAllowedMedia(media) {
    if (!media) return false;

    if (media.closest('header')) return false;
    if (media.closest('.header')) return false;
    if (media.closest('footer')) return false;
    if (media.closest('.footer')) return false;
    if (media.closest('[data-kx-ignore-volume]')) return false;
    if (media.hasAttribute('data-kx-ignore-volume')) return false;

    return !!(
      media.closest('#MainContent') ||
      media.closest('.product-media-modal') ||
      media.closest('media-gallery') ||
      media.closest('.product__media-wrapper')
    );
  }

  function getMediaElements() {
    return Array.prototype.slice
      .call(document.querySelectorAll('video, audio'))
      .filter(isAllowedMedia);
  }

  function hasMedia() {
    return getMediaElements().length > 0;
  }

  function applyToMedia(media) {
    if (!isAllowedMedia(media)) return;

    try {
      media.volume = readVolume();
      media.muted = readMuted();

      if (media.dataset.kxMediaVolumeReady === 'true') return;
      media.dataset.kxMediaVolumeReady = 'true';

      media.addEventListener('play', function () {
        applyToAllMedia();
        showPanel();
      });

      media.addEventListener('playing', function () {
        applyToAllMedia();
        showPanel();
      });

      media.addEventListener('pause', function () {
        scheduleHide();
      });

      media.addEventListener('ended', function () {
        scheduleHide();
      });

      media.addEventListener('volumechange', function () {
        if (!isAllowedMedia(media)) return;
        saveVolume(media.volume);
        saveMuted(media.muted);
        updatePanel();
      });
    } catch (e) {}
  }

  function applyToAllMedia() {
    getMediaElements().forEach(applyToMedia);
    updatePanel();
  }

  function setAllMediaVolume(volume) {
    volume = Math.max(0, Math.min(1, volume));

    saveVolume(volume);
    saveMuted(volume === 0);

    getMediaElements().forEach(function (media) {
      try {
        media.volume = volume;
        media.muted = volume === 0;
      } catch (e) {}
    });

    updatePanel();
    showPanel();
  }

  function setAllMediaMuted(muted) {
    saveMuted(muted);

    if (!muted && readVolume() === 0) {
      saveVolume(DEFAULT_VOLUME);
    }

    getMediaElements().forEach(function (media) {
      try {
        media.volume = readVolume();
        media.muted = muted;
      } catch (e) {}
    });

    updatePanel();
    showPanel();
  }

  function anyMediaPlaying() {
    return getMediaElements().some(function (media) {
      return !media.paused && !media.ended;
    });
  }

  function createPanel() {
    if (document.getElementById('kx-video-volume-panel')) return;

    var style = document.createElement('style');
    style.id = 'kx-video-volume-style';
    style.textContent = `
      #kx-video-volume-panel {
        position: fixed;
        left: 16px;
        bottom: 16px;
        z-index: 9998;
        display: none;
        align-items: center;
        gap: 9px;
        padding: 9px 12px;
        border: 1px solid rgba(198, 167, 122, 0.42);
        border-radius: 999px;
        background: rgba(18, 18, 18, 0.84);
        color: #ffffff;
        backdrop-filter: blur(10px);
        box-shadow: 0 12px 30px rgba(0, 0, 0, 0.22);
        font-family: inherit;
      }

      #kx-video-volume-panel button {
        min-width: 48px;
        height: 32px;
        padding: 0 10px;
        border: 0;
        border-radius: 999px;
        background: rgba(255, 255, 255, 0.14);
        color: #ffffff;
        font-size: 12px;
        font-weight: 700;
        cursor: pointer;
      }

      #kx-video-volume-panel input[type="range"] {
        width: 130px;
        height: 28px;
        cursor: pointer;
        accent-color: #c6a77a;
      }

      #kx-video-volume-panel span {
        min-width: 36px;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.88);
      }

      @media screen and (max-width: 749px) {
        #kx-video-volume-panel {
          left: 10px;
          bottom: 10px;
          padding: 8px 10px;
        }

        #kx-video-volume-panel input[type="range"] {
          width: 96px;
        }
      }
    `;

    document.head.appendChild(style);

    var panel = document.createElement('div');
    panel.id = 'kx-video-volume-panel';
    panel.innerHTML = `
      <button type="button" data-kx-media-mute>Mute</button>
      <input type="range" min="0" max="100" step="1" data-kx-media-volume>
      <span data-kx-media-value>25%</span>
    `;

    document.body.appendChild(panel);

    var muteButton = panel.querySelector('[data-kx-media-mute]');
    var volumeRange = panel.querySelector('[data-kx-media-volume]');

    muteButton.addEventListener('click', function () {
      setAllMediaMuted(!readMuted());
    });

    volumeRange.addEventListener('input', function () {
      setAllMediaVolume(parseInt(volumeRange.value, 10) / 100);
    });

    panel.addEventListener('mouseenter', function () {
      clearHideTimer();
      showPanel();
    });

    panel.addEventListener('mouseleave', function () {
      scheduleHide();
    });

    updatePanel();
  }

  function updatePanel() {
    var panel = document.getElementById('kx-video-volume-panel');
    if (!panel) return;

    var volume = readVolume();
    var muted = readMuted();

    var muteButton = panel.querySelector('[data-kx-media-mute]');
    var volumeRange = panel.querySelector('[data-kx-media-volume]');
    var valueLabel = panel.querySelector('[data-kx-media-value]');

    if (volumeRange) volumeRange.value = Math.round(volume * 100);
    if (valueLabel) valueLabel.textContent = muted ? 'Off' : Math.round(volume * 100) + '%';
    if (muteButton) muteButton.textContent = muted ? 'On' : 'Mute';
  }

  function showPanel() {
    var panel = document.getElementById('kx-video-volume-panel');
    if (!panel || !hasMedia()) return;

    clearHideTimer();
    panel.style.display = 'flex';
    updatePanel();
  }

  function hidePanel() {
    var panel = document.getElementById('kx-video-volume-panel');
    if (!panel) return;

    if (!anyMediaPlaying()) {
      panel.style.display = 'none';
    }
  }

  function clearHideTimer() {
    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }
  }

  function scheduleHide() {
    clearHideTimer();
    hideTimer = setTimeout(hidePanel, 1200);
  }

  function bootScan() {
    applyToAllMedia();

    if (hasMedia()) {
      createPanel();
    }

    scanCount += 1;

    if (scanCount >= 12 && scanTimer) {
      clearInterval(scanTimer);
      scanTimer = null;
    }
  }

  function init() {
    if (isHomepage()) return;

    createPanel();
    bootScan();

    scanCount = 0;

    if (scanTimer) clearInterval(scanTimer);
    scanTimer = setInterval(bootScan, 500);
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
  window.addEventListener('pageshow', init);
  document.addEventListener('shopify:section:load', init);

  document.addEventListener(
    'play',
    function (event) {
      var media = event.target;

      if (media && (media.tagName === 'VIDEO' || media.tagName === 'AUDIO') && isAllowedMedia(media)) {
        applyToMedia(media);
        applyToAllMedia();
        showPanel();
      }
    },
    true
  );

  document.addEventListener(
    'playing',
    function (event) {
      var media = event.target;

      if (media && (media.tagName === 'VIDEO' || media.tagName === 'AUDIO') && isAllowedMedia(media)) {
        applyToMedia(media);
        applyToAllMedia();
        showPanel();
      }
    },
    true
  );

  document.addEventListener(
    'pointerdown',
    function (event) {
      var media = event.target && event.target.closest ? event.target.closest('video, audio') : null;

      if (media && isAllowedMedia(media)) {
        applyToMedia(media);
        applyToAllMedia();

        setTimeout(function () {
          if (!media.paused && !media.ended) {
            showPanel();
          }
        }, 150);
      }
    },
    true
  );
})();